"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCdnPath = getCdnPath;
exports.buildPreloadLink = buildPreloadLink;
exports.buildFontFace = buildFontFace;

var _core = require("@emotion/core");

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));

var _weights = require("./weights");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable global-require */
// https://github.com/IBM/plex/releases


function getCdnPath(fontFolder, fontFile) {
  var fontPath = "".concat(CONFIG.cdnURL, "/fonts/ibmplex/v5.1.3/").concat(fontFolder);
  var cdnIndex = fontFile.split('').reduce(function (a, b) {
    return a + b.charCodeAt(0);
  }, 0) % 4;
  return "".concat(fontPath, "/").concat(fontFile).replace('cdn0', "cdn".concat(cdnIndex));
}

function buildPreloadLink(href) {
  return (0, _core.jsx)("link", {
    rel: "preload",
    as: "font",
    crossOrigin: "anonymous",
    key: href,
    href: href
  });
}

function buildFontFace(_ref) {
  var name = _ref.name,
      localWeight = _ref.localWeight,
      weight = _ref.weight,
      unicodeRange = _ref.unicodeRange,
      isItalic = _ref.isItalic,
      woff = _ref.woff,
      woff2 = _ref.woff2;
  var unicodeSettings = '';

  if (unicodeRange) {
    unicodeSettings = "unicode-range: ".concat(unicodeRange, ";");
  }

  return /*#__PURE__*/(0, _core.css)("@font-face{font-family:\"", (0, _startCase["default"])(name), "\";src:local('", (0, _startCase["default"])(name), " ", "".concat(localWeight || weight).concat(isItalic ? ' Italic' : ''), "'),local('", name, "-", "".concat(localWeight || weight).concat(isItalic ? 'Italic' : ''), "'),url('", woff2, "') format('woff2'),url('", woff, "') format('woff');font-display:swap;font-style:", isItalic ? 'italic' : 'normal', ";font-weight:", _weights.FONT_WEIGHTS[(0, _snakeCase["default"])(weight).toUpperCase()], ";", unicodeSettings, "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}